import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { marked } from "marked";
import DOMPurify from "dompurify";
import "./pujaDetailPage.css";

export default function HomamDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [homam, setHomam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPaying, setIsPaying] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [whatsappMessage, setWhatsappMessage] = useState("");

  const [bookingDate, setBookingDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const [quantity, setQuantity] = useState(1);

  const [extraFields, setExtraFields] = useState([
    { name: "", dob: "", star: "", rashi: "", gotram: "" },
  ]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/pujodetails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ pujoid: id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data) {
          setHomam(data.data);
        } else {
          setHomam(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching puja detail:", error);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paymentStatus = params.get("payment");
    const orderId = params.get("order_id");

    if ((paymentStatus === "success" || paymentStatus === "paid") && orderId) {
      const savedMessage = localStorage.getItem("puja_whatsapp_message");

      setWhatsappMessage(
        savedMessage ||
          `Namaskar 🙏\n\n₹111 astrology consultation payment successful.\nOrder ID: ${orderId}`,
      );

      setSuccessMessage(
        `Payment Successful! Your ₹111 consultation payment is completed. Order ID: ${orderId}`,
      );

      setShowSuccessPopup(true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 1000);
    }

    if (paymentStatus === "failed") {
      setSuccessMessage("Payment failed. Please try again.");
      setShowSuccessPopup(true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 1000);
    }
  }, [location.search]);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (isLoggedIn && pendingAction === "book") {
      setShowModal(true);
      setShowForm(false);
      setErrors({});
      setPendingAction(null);
    }

    if (isLoggedIn && pendingAction === "talk" && homam) {
      const whatsappMessage = `नमस्कार 🙏  
मैं "${homam.title}" से पहले यह जानना चाहता/चाहती हूँ कि मेरी जन्म कुंडली में कोई बाधा विद्यमान है या नहीं।

कृपया वेद विशेषज्ञ से परामर्श की प्रक्रिया, समय और भुगतान विवरण साझा करने की कृपा करें।

आपकी सहायता के लिए धन्यवाद`;

      window.open(
        `https://wa.me/919616339090?text=${encodeURIComponent(whatsappMessage)}`,
        "_blank",
      );

      setPendingAction(null);
    }
  }, [pendingAction, homam]);

  const handleFieldChange = (index, field, value) => {
    const updatedFields = [...extraFields];
    updatedFields[index][field] = value;
    setExtraFields(updatedFields);
  };

  const createMarkup = (htmlText) => {
    return { __html: DOMPurify.sanitize(marked.parse(htmlText || "")) };
  };

  const handlePayClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      setPendingAction("book");
      navigate("/login", { state: { from: location } });
      return;
    }

    setShowModal(true);
    setShowForm(false);
    setErrors({});
  };

  const handleTalkToAstrologer = (e) => {
    e.preventDefault();

    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      setPendingAction("talk");
      navigate("/login", { state: { from: location } });
      return;
    }

    const whatsappMessage = `नमस्कार 🙏  
मैं "${homam?.title}" से पहले यह जानना चाहता/चाहती हूँ कि मेरी जन्म कुंडली में कोई बाधा विद्यमान है या नहीं।

कृपया वेद विशेषज्ञ से परामर्श की प्रक्रिया, समय और भुगतान विवरण साझा करने की कृपा करें।

आपकी सहायता के लिए धन्यवाद`;

    window.open(
      `https://wa.me/919616339090?text=${encodeURIComponent(whatsappMessage)}`,
      "_blank",
    );
  };

  const handleClose = () => {
    setShowModal(false);
    setShowForm(false);
    setIsPaying(false);
    setForm({
      name: "",
      email: "",
      phone: "",
    });
    setErrors({});
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    setForm({ ...form, [name]: value });

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateConsultationForm = () => {
    const newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Enter Name";
    }

    if (!form.email.trim()) {
      newErrors.email = "Enter Email";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Invalid Email";
    }

    if (!form.phone.trim()) {
      newErrors.phone = "Enter Phone";
    } else if (form.phone.length !== 10) {
      newErrors.phone = "Invalid Phone";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePayment = async () => {
    if (!homam) return;
    if (!validateConsultationForm()) return;

    try {
      setIsPaying(true);

      const whatsappText = `नमस्कार 🙏

₹111 astrology consultation payment successful.

Customer Details:
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}

Puja Details:
Puja: ${homam?.title || ""}
Booking Date: ${bookingDate}
Quantity: ${quantity}

Please guide me further for the puja booking.

– Team JyotirVani`;

      localStorage.setItem("puja_whatsapp_message", whatsappText);

      const res = await fetch(
        "https://dashboard.jyotirvani.com/api/generate-token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            amount: 111,
            name: form.name,
            email: form.email,
            phone: form.phone,
            type: "puja_consultation",
            item_name: "Puja ₹111 Consultation",
            item_type: "puja_consultation",
            puja_id: homam.id,
            puja_name: homam.title,
            booking_date: bookingDate,
            quantity: Number(quantity),
          }),
        },
      );

      const text = await res.text();
      console.log("RAW PAYMENT RESPONSE:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (error) {
        alert("Backend JSON return korche na");
        setIsPaying(false);
        return;
      }

      console.log("PAYMENT RESPONSE:", data);

      if (!res.ok || !data.status) {
        alert(data.message || "Payment request failed");
        setIsPaying(false);
        return;
      }

      if (!window.Razorpay) {
        alert("Razorpay SDK load hoyni");
        setIsPaying(false);
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: "JyotirVani",
        description: "Puja ₹111 Consultation",
        order_id: data.order_id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              "https://dashboard.jyotirvani.com/api/verify-razorpay-payment",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  local_order_id: data.local_order_id,
                  return_type: "puja_consultation",
                }),
              },
            );

            const verifyData = await verifyRes.json();

            if (verifyData.status) {
              const user = JSON.parse(localStorage.getItem("user") || "null");

              const historyKey = user?.email
                ? `payment_history_${user.email}`
                : "payment_history_guest";

              const oldHistory =
                JSON.parse(localStorage.getItem(historyKey)) || [];

              const newHistory = {
                order_id: data.local_order_id,
                type: "puja",
                title: homam?.title || "Puja Consultation",
                amount: 111,
                payment_status: "success",
                payment_mode: "Razorpay",
                date: new Date().toISOString(),
              };

              localStorage.setItem(
                historyKey,
                JSON.stringify([newHistory, ...oldHistory]),
              );

              setShowModal(false);

              setWhatsappMessage(whatsappText);

              setSuccessMessage(
                `Payment Successful! Your ₹111 consultation payment is completed. Order ID: ${
                  data.local_order_id || ""
                }`,
              );

              setShowSuccessPopup(true);

              setIsPaying(false);
            } else {
              alert(verifyData.message || "Payment verification failed");
              setIsPaying(false);
            }
          } catch (err) {
            console.error("VERIFY ERROR:", err);
            alert("Payment verification failed");
            setIsPaying(false);
          }
        },

        prefill: {
          name: form.name,
          email: form.email,
          contact: form.phone,
        },

        notes: {
          local_order_id: data.local_order_id,
          puja_id: homam.id,
          puja_name: homam.title,
        },

        theme: {
          color: "#7c3aed",
        },

        modal: {
          ondismiss: function () {
            setIsPaying(false);
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment Error:", error);
      alert("Payment failed. Please try again.");
      setIsPaying(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!homam) return <p>Puja not found</p>;

  return (
    <div className="ra-main-puja-part">
      {showSuccessPopup && (
        <div className="qr-modal-overlay">
          <div className="qr-modal-content" style={{ textAlign: "center" }}>
            <h2 style={{ color: "green" }}>Payment Successful 🎉</h2>
            <p>{successMessage}</p>

            <button
              className="ra-plan-contact-btn"
              onClick={() => {
                if (whatsappMessage) {
                  window.open(
                    `https://wa.me/919616339090?text=${encodeURIComponent(
                      whatsappMessage,
                    )}`,
                    "_blank",
                    "noopener,noreferrer",
                  );
                }

                localStorage.removeItem("puja_whatsapp_message");
                setShowSuccessPopup(false);
              }}
            >
              Continue WhatsApp
            </button>
          </div>
        </div>
      )}

      <div className="container">
        <div className="ra-puja-part">
          <div className="row">
            <div className="col-md-6">
              <div className="puja-detail-section1">
                <img
                  src={`https://dashboard.jyotirvani.com/uploads/pujobanner/${homam.image}`}
                  alt={homam.title}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="puja-detail-section2">
                <h2>{homam.title}</h2>
                <p className="homam-category">Category: {homam.category}</p>

                <h3>Booking Information</h3>

                <input
                  type="date"
                  className="homam-select mb-2"
                  value={bookingDate}
                  onChange={(e) => setBookingDate(e.target.value)}
                />

                <p className="modal-subtext">
                  Name is required. Other fields are optional.
                </p>

                {extraFields.map((field, idx) => (
                  <div key={idx} className="modal-field-group">
                    <div className="ra-db-row">
                      <input
                        type="text"
                        placeholder="Name *"
                        className="homam-select"
                        value={field.name}
                        onChange={(e) =>
                          handleFieldChange(idx, "name", e.target.value)
                        }
                      />

                      <input
                        type="date"
                        className="homam-select"
                        value={field.dob}
                        onChange={(e) =>
                          handleFieldChange(idx, "dob", e.target.value)
                        }
                      />

                      <input
                        type="text"
                        placeholder="Father Name"
                        className="homam-select"
                        value={field.star}
                        onChange={(e) =>
                          handleFieldChange(idx, "star", e.target.value)
                        }
                      />

                      <input
                        type="text"
                        placeholder="Gotram"
                        className="homam-select"
                        value={field.gotram}
                        onChange={(e) =>
                          handleFieldChange(idx, "gotram", e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}

                <div className="ra-db-prize-row">
                  <div className="ra-db-left-part">
                    <p className="homam-price">₹ {homam.price}</p>

                    <input
                      type="number"
                      min="1"
                      value={quantity}
                      className="quantity-input"
                      placeholder="Qty"
                      onChange={(e) =>
                        setQuantity(Math.max(1, Number(e.target.value) || 1))
                      }
                    />
                  </div>

                  <div className="ra-db-right-part">
                    <button className="book-now-btn" onClick={handlePayClick}>
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showModal && (
            <div className="qr-modal-overlay">
              <div className="qr-modal-content">
                <div className="payment-form">
                  {!showForm ? (
                    <>
                      <h3>
                        ₹111 astrology consultation is mandatory prior to puja
                        booking
                      </h3>

                      <div className="payment-buttons">
                        <button
                          type="button"
                          className="ra-plan-contact-btn"
                          onClick={() => setShowForm(true)}
                        >
                          ₹111
                        </button>

                        <button
                          type="button"
                          className="ra-plan-close-btn"
                          onClick={handleClose}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <h3>Enter Your Details</h3>

                      <div className="input-group">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={form.name}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.name && <p className="error">{errors.name}</p>}

                      <div className="input-group">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={form.email}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.email && <p className="error">{errors.email}</p>}

                      <div className="input-group">
                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone"
                          value={form.phone}
                          onChange={handleChange}
                          maxLength={10}
                        />
                      </div>
                      {errors.phone && <p className="error">{errors.phone}</p>}

                      <div className="payment-buttons">
                        <button
                          type="button"
                          className="ra-plan-contact-btn"
                          onClick={handlePayment}
                          disabled={isPaying}
                        >
                          {isPaying ? "Processing..." : "Pay ₹111"}
                        </button>

                        <button
                          type="button"
                          className="ra-plan-close-btn"
                          onClick={handleClose}
                          disabled={isPaying}
                        >
                          Cancel
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="ra-puja-description">
            <div dangerouslySetInnerHTML={createMarkup(homam.description)} />
            <button
              className="ra-shop-detail-puja-btn"
              onClick={handleTalkToAstrologer}
              type="button"
            >
              Talk to Astrologer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
